import { announceStorage } from "./storageEvents";
// Light/dark theme + accent palette persistence. The actual styling lives in
// globals.css (`html.dark` token overrides and `[data-accent="…"]` palettes);
// here we just persist the choices and reflect them on <html>.
export type Theme = "light" | "dark";
export type Accent = "mint" | "blue" | "indigo" | "purple" | "rose" | "amber";

const THEME_KEY = "pp_theme";
const ACCENT_KEY = "pp_accent";

export const ACCENTS: Accent[] = ["mint", "blue", "indigo", "purple", "rose", "amber"];

// Representative swatch color (light-mode primary) for each accent.
export const ACCENT_HEX: Record<Accent, string> = {
  mint: "#0d6e5a",
  blue: "#2563eb",
  indigo: "#5b4fcf",
  purple: "#8b5cf6",
  rose: "#e11d48",
  amber: "#d97706",
};

export function getTheme(): Theme {
  if (typeof window === "undefined") return "light";
  return localStorage.getItem(THEME_KEY) === "dark" ? "dark" : "light";
}

export function setTheme(theme: Theme): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(THEME_KEY, theme);
  document.documentElement.classList.toggle("dark", theme === "dark");
  announceStorage();
}

export function getAccent(): Accent {
  if (typeof window === "undefined") return "mint";
  const stored = localStorage.getItem(ACCENT_KEY);
  return (ACCENTS as string[]).includes(stored ?? "") ? (stored as Accent) : "mint";
}

export function setAccent(accent: Accent): void {
  if (typeof window === "undefined") return;
  localStorage.setItem(ACCENT_KEY, accent);
  document.documentElement.setAttribute("data-accent", accent);
  announceStorage();
}

// Inline <script> body injected in the root layout so theme + accent are applied
// before first paint (no flash of the wrong theme/color on load).
export const THEME_INIT_SCRIPT = `(function(){try{var d=document.documentElement;if(localStorage.getItem('pp_theme')==='dark'){d.classList.add('dark');}d.setAttribute('data-accent',localStorage.getItem('pp_accent')||'mint');}catch(e){}})();`;
